<template>
    <div>
      <b-card>
      
      <!-- table -->
      <b-table
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        :items="form"
        :fields="fields"
        responsive
        striped
        fixed
        
      >
      <template #cell(question)="data">
       <div style="font-size:14px;">{{  data.item.question }}  </div>
      </template>
      <template #cell(answer)="data">
        <b-form-rating
            v-if="data.item.type == 'RATING'"
            no-border
            size="lg"
            v-model="data.item.answer" 
            
            variant="warning"
            style="background-color: transparent"
            />
            <b-form-checkbox
                v-if="data.item.type == 'RADIO'"
                checked="false"
                v-model="data.item.answer" 
                class="custom-control-success"
                name="check-button"
                switch
            />
           <b-form-textarea
               v-if="data.item.type == 'TEXT'"
              v-model="data.item.answer" 
              rows="8"
              size="lg"
            />

            <v-select
            v-if="data.item.type == 'SELECT'"
            :options="data.item.select"
            :reduce="ans => ans.label"
            v-model="data.item.answer"
            menu-props="{ zIndex: 1200 }"
            taggable
            multiple
            />
            
        </template>
      </b-table>
      <b-row>
        
      </b-row>
      <b-button @click="submit_form()">Submit</b-button>
    </b-card>
    </div>
  </template>
  
  <script>
  import BCardCode from '@core/components/b-card-code/BCardCode.vue'
  import vSelect from 'vue-select'
  import flatPickr from 'vue-flatpickr-component'
  import moment from 'moment'
  import router from '@/router'

  import Ripple from 'vue-ripple-directive'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import {
    BFormCheckbox,BTable, BAvatar, BFormTextarea,BCardBody,BFormRating, BCard, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,
  } from 'bootstrap-vue'

  export default {
    components: {
        BFormCheckbox,
      BTable,
      BAvatar,
      BFormTextarea,
      BBadge,
      BRow,
      flatPickr,
      moment,
      BCard,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BFormRating,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BInputGroupPrepend,
      BButton,
      BPagination,
      BCardCode,
      BTable,
      BButton,
      BFormGroup,
      BAvatar,
      BCardBody,
      BBadge,
      vSelect,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        form_id : null,
        form : [],
        genderOptions: [
          { label: 'Male', value: 'M' },
          { label: 'Female', value: 'F' },
        ],
        planOptions: [
          { label: 'Basic', value: 'basic' },
          { label: 'Company', value: 'company' },
          { label: 'Enterprise', value: 'enterprise' },
          { label: 'Team', value: 'team' },
        ],
        statusOptions: [
          { label: 'Active', value: 'active' },
          { label: 'Disabled', value: 'disabled' },
        ],
        status: [{
          1: 'ACTIVE', 2: 'DISABLED', 3: 'DELETED'
        },
        {
          1: 'light-success', 2: 'danger', 3: 'info'
        }],
        centerOptions: [],
        isAddNewMemberSidebarActive: false,
        searchString: null,
        answer:[],
        rollback : false,
        existData:null,
        perPage: 10,
        action:'edit',
        startRow: 1,
        endRow: 10,
        pageOptions: [10, 15, 20],
        totalRows: 1,
        currentPage: 1,
        fields: [
          { key: 'question', label: "問題",thStyle: { width: '60%' }, tdStyle: { width: '40%' } },
          { key: 'answer', label: "答案"},
        ],
        /* eslint-disable global-require */
        items: [],
        /* eslint-disable global-require */
        status: [{
          1: 'Active', 2: 'Disabled', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
        },
        {
          1: 'light-success', 2: 'light-danger', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
        }],
        selectMode: 'single',
        selected: [],
      }
    },

   
    created() {
        this.form_id = router.currentRoute.params.form_id
        this.get_data()
    },
    methods: {
//         onRatingChange(item) {
//       // 禁止選擇 1 或 2
//       if (item.answer === 1 || item.answer === 2) {
//         // 清除選擇或還原為 null / 原值
//         item.answer = null; // 或改成你想顯示嘅 fallback 分數
//         this.$toast({
//                     component: ToastificationContent,
//                     position: 'top-center',
//                     props: {
//                     title: 'Error',
//                     icon: 'XIcon',
//                     variant: 'danger',
//                     text: '禁止選擇低於3星',
//                     },
//       })
//     }
// },
      submit_form() {
        this.$http.post(process.env.VUE_APP_API_BASE+`/form/answer/add/?student_id=`+router.currentRoute.params.student_id,{
            form:this.form,
            enrollment_id:this.$route.query.enrollment_id,
            item_id: this.$route.query.item_id
        } )
          .then(res => {
            if (res.data.result === false) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                    title: 'Error',
                    icon: 'XIcon',
                    variant: 'danger',
                    text: res.data.message,
                    },
          }) 
            } else if (res.data.result === true) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                        title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                    text: '新增成功'
                    },
                }) 
                                this.$router.replace('/apps/student/edit/'+res.data.student);
            }
          })
      },
      get_data() {
        this.$http.get(process.env.VUE_APP_API_BASE+`/form/${this.form_id}/`)
          .then(res => {     
            this.form = res.data.form
          })
      },   
    },
  }
  </script>
  
  <style lang="scss">
  .v-select {
    width:100%;
  }
  .v-menu__content {
    z-index:99999 !important;
  }
  .b-table-selectable{
    .feather{
      font-size: 1.3rem;
    }
  }
  
  </style>
  